import React, { useEffect } from "react";
import Navbar from "../components/layout/navbar";
import Footer from "../components/layout/footer";
import Featuresbanner from "../components/pages/Features/featuresbanner";
import Cardssection from "../components/pages/Features/cardssection";

const Features = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Featuresbanner />
      <Cardssection />
      <Footer />
    </>
  );
};

export default Features;
